// ==========================================================================
// Lightbox
// ==========================================================================
/* jshint esnext: true */
import { $document, $html, APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'Lightbox';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor (options) {
        super(options);

        this.$el.slickLightbox({
            itemSelector: '.js-lightbox-item',
            caption: 'caption'
        });
    }

    destroy() {
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
